import {
    Component, EventEmitter, HostListener, OnDestroy, OnInit, Output,
} from "@angular/core";
import { Observable, Subject, Subscription, forkJoin, interval } from "rxjs";
import { map, takeUntil } from "rxjs/operators";
import { EmitterService } from "src/app/EmitterService";
import { AppService } from "src/app/app.service";

@Component({
    selector: "app-navbar-style-three",
    templateUrl: "./navbar-style-three.component.html",
    styleUrls: ["./navbar-style-three.component.scss"],
})
export class NavbarStyleThree implements OnInit, OnDestroy {
    loadingData = true;
    isScrolled = false;
    isSmall: boolean;
    isBig = true;
    isLeft = true;
    isMiddle = false;
    subscription: Subscription;
    currentDay: string;
    currentTime: string;
    currentDate: string;
    Notices = [];
    array1 = [];
    array2 = [];
    currentDateTime$: Observable<string>;
    mainData: any;
    sortedNotice: any;
    private ngUnsubscribe = new Subject();
    @Output() parametersReady = new EventEmitter<any>();
    AllmenuItems: any[];

    constructor(
        private appService: AppService,
        private emitterService: EmitterService
    ) {
        this.smallScreen();
    }

    ngOnInit(): void {
        this.currentDateTime$ = interval(1000).pipe(
            map(() => {
                const currentDate = new Date();
                const dayOfWeek = this.getDayOfWeek(currentDate);
                const time = this.getTime(currentDate);
                const month = this.getMonth(currentDate);
                const day = currentDate.getDate();
                const year = currentDate.getFullYear();
                return `${dayOfWeek} ${" | "}  ${time}  ${" | "}   ${month} ${day}, ${year}`;
            })
        );

        this.FetchMainData();
    }

    ngOnDestroy() {
        this.ngUnsubscribe.next(null);
        this.ngUnsubscribe.complete();
    }

    FetchMainData() {
        const cachedMainData = localStorage.getItem("mainData");
        if (cachedMainData) {
            this.mainData = JSON.parse(cachedMainData);
            this.buildMenu();
        }

        forkJoin([
            this.appService.getClientBasics(),
            this.appService.getNotices(),
        ])
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(
                (response: any) => {
                    this.mainData = response[0].data;

                    this.sortedNotice = this.sortByStartDate(response[1].data);
                    if (this.sortedNotice != null) {
                        let scrollFiltered = this.sortedNotice.filter(
                            (x) => x.ShowScroll === true
                        );

                        this.Notices = scrollFiltered.sort(
                            (a, b) => b.Id - a.Id
                        );
                    }

                    this.buildMenu();
                    
                    if (this.mainData) {
                        localStorage.setItem(
                            "mainData",
                            JSON.stringify(this.mainData)
                        );
                    }

                    if (this.sortedNotice != null && this.mainData != null) {
                        this.loadingData = false;
                        this.emitterService.changeMessage(true);
                    }
                },
                (error) => {
                    console.error("Error:", error);
                }
            );
    }

    buildMenu() {
        if (this.mainData != null) {
            let siteMapSorted = [];
            let newArraay = [];

            this.mainData.SiteMapList.forEach((item) => {
                if (
                    item.MenuCode != 187 &&
                    item.MenuCode != 216 &&
                    item.MenuCode != 217 &&
                    item.MenuCode != 300 &&
                    item.MenuCode != 647 &&
                    item.MenuCode != 2
                ) {
                    newArraay.push({
                        ...item,
                        Items: [],
                    });
                }
            });

            newArraay.forEach((item) => {
                if (item.ParentId === 0) {
                    siteMapSorted.push({
                        ...item,
                        Items: [],
                    });
                }
            });

            newArraay.forEach((item) => {
                if (item.ParentId !== 0) {
                    let parentItem = siteMapSorted.find(
                        (parent) => parent.Id === item.ParentId
                    );
                    if (parentItem) {
                        parentItem.Items.push(item);
                    }
                }
            });

            siteMapSorted.forEach((parent) => {
                if (parent.Items.length > 0) {
                    parent.Items.sort((a, b) => a.MenuOrder - b.MenuOrder);
                }
            });

            this.AllmenuItems = siteMapSorted;

            const middleIndex = Math.ceil(siteMapSorted.length / 2);
            this.array1 = siteMapSorted.slice(0, middleIndex);
            this.array2 = siteMapSorted.slice(middleIndex);
        }
    }

    private getDayOfWeek(date: Date): string {
        const days = [
            "Sunday",
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday",
        ];
        return days[date.getDay()];
    }

    private getTime(date: Date): string {
        const hours = date.getHours() % 12 || 12;
        const minutes = date.getMinutes();
        const ampm = date.getHours() < 12 ? "AM" : "PM";
        return `${hours}:${minutes < 10 ? "0" : ""}${minutes} ${ampm}`;
    }

    private getMonth(date: Date): string {
        const months = [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December",
        ];
        return months[date.getMonth()];
    }

    @HostListener("window:resize")
    onResize() {
        this.smallScreen();
    }

    @HostListener("window:scroll", [])
    onWindowScroll() {
        this.isScrolled = window.pageYOffset > 0;
    }

    smallScreen() {
        this.isSmall = window.innerWidth <= 1200;
        this.isBig = window.innerWidth > 1200;
        this.isLeft = window.innerWidth > 1300;
        this.isMiddle = window.innerWidth <= 1300;
    }

    onNavigate(url: string) {
        let MyUrl = "";
        if (url.startsWith("http://") || url.startsWith("https://")) {
            MyUrl = url;
        } else {
            MyUrl = "https://" + url;
        }
        window.open(MyUrl, "_blank");
    }

    NoAdmissionAlert() {
        alert("Admission services not open yet.");
        return;
    }

    private getTimeFull(date?: Date) {
        return date != null ? new Date(date).getTime() : 0;
    }

    public sortByStartDate(array: any): any {
        return array.sort((a: any, b: any) => {
            return (
                this.getTimeFull(b.CreatedDate) -
                this.getTimeFull(a.CreatedDate)
            );
        });
    }
}